// extracted by mini-css-extract-plugin
export default {"body":"fail_body__GAMAQ","gracias":"fail_gracias__0riIL","img":"fail_img__nnkWb"};